import { getToken } from '../store/utils';

/**
 * Checks if the recording comes from a product link (feedback response / shared recording),
 * in order to display the jumpstart filter underline tooltip.
 */
export const isRecordingFromProductLink = (): boolean => {
  const sharingToken = getToken() || '';
  const isSharedRecording = Boolean(sharingToken);

  return window.location.href.includes('incoming-feedback-response') || isSharedRecording;
};
